import React, { useEffect, useState } from 'react';

import { useIntl } from 'react-intl';

import Button from '@atlaskit/button/new';
import { useFormState } from '@atlaskit/form';
import { Inline } from '@atlaskit/primitives/compiled';
import type { ActionKeys } from '@atlassian/conversation-assistant-message-actions-api/constants';
import type { ActionRendererKeyToPayload } from '@atlassian/conversation-assistant-message-actions-api/types';

import messages from './messages';

export const JiraVersionCreateFormFooter = ({
	readonly,
	status,
}: {
	readonly: boolean;
	status: string;
}): React.JSX.Element => {
	const intl = useIntl();
	const formState = useFormState<ActionRendererKeyToPayload[typeof ActionKeys.JiraVersionCreate]>({
		invalid: true,
		submitting: true,
		values: true,
	});
	const [isDisabledState, setIsDisabledState] = useState(readonly);
	useEffect(() => {
		setIsDisabledState(
			readonly || Boolean(formState?.invalid) || !formState?.values?.name || status === 'started',
		);
	}, [formState, readonly, status]);

	return (
		<Inline space="space.100">
			<Button
				type="submit"
				appearance="primary"
				isDisabled={isDisabledState}
				isLoading={formState?.submitting}
			>
				{intl.formatMessage(messages.saveRelease)}
			</Button>
		</Inline>
	);
};
